import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../components/Layout';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => (
  <div className="min-h-screen bg-[#1A1A1A] flex flex-col">
    <Header />
    <main className="flex-1 max-w-3xl mx-auto px-4 py-8 w-full">
      <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white mb-6 text-sm">
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
      <h1 className="text-3xl font-black uppercase text-white mb-8" style={{ fontFamily: 'Outfit' }}>
        Privacy <span className="text-[#D4AF37]">Policy</span>
      </h1>
      <div className="card-dark prose-invert space-y-6 text-gray-300 text-sm leading-relaxed">
        <p className="text-gray-400 text-xs">Last updated: April 2026</p>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">1. Information We Collect</h2>
          <p>We collect information you provide during registration including your full name, email address, phone number, and country. We also collect transaction data, betting history, and device information for security purposes.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">2. KYC Data</h2>
          <p>For identity verification, we may collect government-issued ID documents, selfie photographs, and proof of address. This data is stored securely and used solely for identity verification and regulatory compliance.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">3. How We Use Your Data</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>To create and manage your account</li>
            <li>To process bets, payments, and withdrawals</li>
            <li>To verify your identity (KYC compliance)</li>
            <li>To prevent fraud and enforce our Terms of Service</li>
            <li>To send notifications about your bets and account activity</li>
            <li>To improve our platform and user experience</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">4. Data Sharing</h2>
          <p>We do not sell your personal data. We may share data with payment processors for transaction completion, law enforcement when required by law, and our KYC verification partners. Your betting activity is visible to other users only in anonymized form unless you create public bets.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">5. Data Security</h2>
          <p>We use industry-standard encryption (SSL/TLS) for all data transmission. Passwords are hashed using bcrypt. Payment data is handled by PCI-compliant processors. Access to personal data is restricted to authorized personnel only.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">6. Cookies</h2>
          <p>We use essential cookies for authentication and session management. We do not use third-party tracking cookies for advertising purposes.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">7. Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data. You may request a copy of all data we hold about you. To exercise these rights, email us at <a href="mailto:info@krazybets.online" className="text-[#D4AF37] hover:underline">info@krazybets.online</a>.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">8. Data Retention</h2>
          <p>We retain your account data for as long as your account is active. Transaction records are kept for 7 years for regulatory compliance. You may request account deletion at any time, subject to outstanding obligations.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">9. Contact</h2>
          <p>For privacy concerns, contact our Data Protection Officer at <a href="mailto:info@krazybets.online" className="text-[#D4AF37] hover:underline">info@krazybets.online</a></p>
        </section>

        <div className="border-t border-[#3D3D3D] pt-4 mt-8">
          <p className="text-gray-500 text-xs">© 2026 KrazyBets. All rights reserved. Owned and trademarked by Qfinity Media Group.</p>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default PrivacyPage;
